import React from 'react';
import { Flex, Text, Box, Card } from '../design-system';
import { formatTime, renderMultilineText } from '../helpers/utils';

interface MemberNoteProps {
  cell: { value: any };
  type?: string;
}

const MemberNote = ({ cell: { value }, type }: MemberNoteProps) => {
  if (Array.isArray(value)) {
    return (
      <Flex flexDirection="column" justifyContent="center">
        <Text fontWeight="bold" fontSize={14} mb={1}>
          Notes
        </Text>
        {value.map(({ id, title, created_at, creator }) => {
          return (
            <Card p={1} mb={1} key={id}>
              <Flex key={id} alignItems="center">
                <Box>
                  <Text fontSize={13}>{renderMultilineText(title)}</Text>
                </Box>
              </Flex>
              {creator && created_at && (
                <Flex mt={2} alignItems="center">
                  <Text fontWeight="bold" fontSize={12}>
                    Created by: {creator.name} {formatTime(created_at)}
                  </Text>
                </Flex>
              )}
            </Card>
          );
        })}
      </Flex>
    );
  }

  return (
    value && (
      <Card p={1} mb={1}>
        <Text fontWeight="bold" fontSize={14} mb={1}>
          {type && type} Note
        </Text>
        <Flex alignItems="center">
          <Box>
            <Text fontSize={13}>{renderMultilineText(value)}</Text>
          </Box>
        </Flex>
      </Card>
    )
  );
};

export default MemberNote;
